<nz-alert
    nzType="warning"
    [nzDescription]="infoTemplate"
>

<ng-template #infoTemplate>
  <span>Your license agreement will expire on {{ expiryDate * 1000 | date:'dd/MM/yyyy' }} ({{ daysLeft }} days left). Click to <a (click)="renew()">Renew It</a>. </span>
</ng-template>

</nz-alert>
